import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=05a790d6&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a790d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a790d6')) {
      api.createRecord('05a790d6', component.options)
    } else {
      api.reload('05a790d6', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=05a790d6&scoped=true&", function () {
      api.rerender('05a790d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/textarea.vue"
export default component.exports